import i18n from "i18next";

export const getLanguage = () => {
  switch (i18n.language) {
    case "ar":
      return "Arabic";
    case "bn":
      return "Bangla";
    default:
      return "English";
  }
};
